import './Card.css'

export default function Card() {
  return (
    <div className='Card'>
        <div className='cardContent'>
            <p>
                Happy birthday to my best friend, lover and princess!
            </p>
            <p>
                A basic card could not express how deep and all consuming my love is for you. I needed to create something special <strong>just for you</strong>!&nbsp;&nbsp;&#128150;&#128150;
            </p>
            <p>
                I have never met someone who I want to hug, kiss...and choke out; all at the same time &#128518;.
            </p>
            <p>
                You are so beautiful, smart, funny, charming and full of love; that I am constantly in awe when I experience any amount of time with you.
            </p>
            <p>
                Your smile melts my "tough" heart, your voice makes me want to say yes all the time and your touch makes me lose all rational thoughts.
            </p>
            <p>
                I am so fortunate to have you in my life and I hope I can be there to continue watching you grow in strength and wisdom.
            </p>
            <br />
            <p>
                Love &#128536;,
            </p>
            <p>
                Precious
            </p>
        </div>
    </div>
  )
}
